import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../layout';
import { RootState } from '../../../redux/types';
import sequenceConfig from '../../../sequence/sequence-config';
import { Type } from '../../../types/instant-lease-api';
import Navigation from '../../../utils/navigation';
import SequencesPhases from '../../b2b/components/sequences-phases/sequences-phases';
import Spinner from '../../b2b/components/spinner/spinner';
import ButtonGroup from '../../b2b/molecules/button-group/button-group';

const StatusPending: React.FC = () => {
  // Sequence config
  const config = sequenceConfig();

  // Sequence Store
  const { sequence, step } = useSelector((state: RootState) => state.sequence);

  const { activeApplication } = useSelector(
    (state: RootState) => state.leaseApp,
  );

  // Navigate hook
  const navigate = useNavigate();

  // Navigation class
  const { nextRoute } = new Navigation();

  const isButtonDisabled = (): boolean => {
    return !activeApplication?.uuid;
  };

  return activeApplication ? (
    <Layout
      heading={config[sequence]?.title}
      subHeading={config[sequence]?.subTitle}
      hasFullSize={true}
      className={`status-overview grid`}
      style={{ gridTemplateRows: '15% 60%' }}
    >
      <SequencesPhases
        sequence={sequence}
        partner={activeApplication.partner}
        type={activeApplication.type || Type.B2B}
        config={config}
        step={step}
      />
      <ButtonGroup
        className='back-next medium'
        type='back-next'
        buttonOneProps={{
          theme: 'primary',
          type: 'button',
          onClick: () => navigate(nextRoute()),
          disabled: isButtonDisabled(),
          children: activeApplication?.uuid ? 'weiter' : <Spinner />,
        }}
      />
    </Layout>
  ) : null;
};

export default StatusPending;
